// extracted by mini-css-extract-plugin
export var Hero = "r_y";
export var aniSpin = "r_d";
export var image = "r_D";
export var inner = "r_r";
export var slide = "r_B";
export var staticLayout = "r_C";
export var wipe = "r_z";